import { EStudentCalendarEventType } from '@constants';
import styled, { css } from 'styled-components';

export const TitleWrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  align-items: center;
`;

export const Wrapper = styled.div<{ $type: EStudentCalendarEventType }>`
  display: flex;
  flex-direction: row;
  padding: 0px 8px;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  border-radius: 2px;
  color: ${({ theme }) => theme.colors.black9};
  border-left: 4px solid ${({ theme }) => theme.colors.black6};
  background-color: ${({ theme }) => theme.colors.black1};
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  :hover {
    background-color: ${({ theme }) => theme.colors.black2};
  }
  ${({ $type }) => {
    switch ($type) {
      case EStudentCalendarEventType.VIEWED:
        return css`
          border-color: ${({ theme }) => theme.colors.green6};
          background-color: ${({ theme }) => theme.colors.green1};
          :hover {
            background-color: ${({ theme }) => theme.colors.green2};
          }
        `;
      case EStudentCalendarEventType.NOT_VIEWED:
        return css`
          border-color: ${({ theme }) => theme.colors.orange6};
          background-color: ${({ theme }) => theme.colors.orange1};
          :hover {
            background-color: ${({ theme }) => theme.colors.orange2};
          }
        `;
      case EStudentCalendarEventType.TUTORIAL:
        return css`
          border-color: ${({ theme }) => theme.colors.blue6};
          background-color: ${({ theme }) => theme.colors.blue1};
          :hover {
            background-color: ${({ theme }) => theme.colors.blue2};
          }
        `;
      default:
        return css`
          border-color: ${({ theme }) => theme.colors.black6};
          background: ${({ theme }) => theme.colors.black1};
          :hover {
            background-color: ${({ theme }) => theme.colors.black2};
          }
        `;
    }
  }}
`;
